import { action, makeAutoObservable, observable, runInAction } from "mobx"
import { viewItems , SENTIMENTS} from "../../components/constants"
import { getLocalStorage, setLocalStorage } from "../../utils"
import { toJS } from 'mobx';
import { CREATE_VIDEO, CHART, CHERRY_PICK } from "../../components/constants"
// Default video widths for each view
const DEFAULT_VIDEO_WIDTHS = (() => {
    const savedWidths = getLocalStorage('videoWidths') || {};
    return {
        'AIB': savedWidths['AIB'] || 60,
        'Auto Highlight': savedWidths['Auto Highlight'] || 140,
        'Cherry Pick': savedWidths['Cherry Pick'] || 120,
        'Create a Video': savedWidths['Create a Video'] || 140,
        'Content Moderation': savedWidths['Content Moderation'] || 10,
        'Entities': savedWidths['Entities'] || 80,
        'Charts': savedWidths['Charts'] || 100
    };
})();

class FilterStore {

    currentView = 'Create a Video'
    // filters
    sentiments   = viewItems.reduce((acc, item) => {
        acc[item] = SENTIMENTS
        return acc
    }, {})
    speakers = viewItems.reduce((acc, item) => {
        acc[item] = {'A': false}
        return acc
    }, {})
    length = viewItems.reduce((acc, item) => {
        acc[item] = []
        return acc
    }, {})
    sec = viewItems.reduce((acc, item) => {
        acc[item] = []
        return acc
    }, {})
    search = viewItems.reduce((acc, item) => {
        acc[item] = ''
        return acc
    }, {})

    subtitles = viewItems.reduce((acc, item) => {
        acc[item] = true
        return acc
    }, {})
    
    spaces = viewItems.reduce((acc, item) => {
        acc[item] = false
        return acc
    }, {})
    selectedSentences = viewItems.reduce((acc, item) => {
        acc[item] = []
        return acc
    }, {})
    
    // Video width settings - view-specific defaults with localStorage persistence
    videoWidth = (() => {
        const savedVideoWidths = getLocalStorage('videoWidths') || {};
        return viewItems.reduce((acc, item) => {
            acc[item] = savedVideoWidths[item] || DEFAULT_VIDEO_WIDTHS[item] || 80;
            return acc;
        }, {});
    })()

    highlights = {} // { [clipId]: { start: wordIdx, end: wordIdx } }

    constructor() {
        makeAutoObservable(this, {
            sentiments: observable,
            length: observable,
            sec: observable,
            speakers: observable,
            search: observable,
            selectedSentences: observable,
            subtitles: observable,
            spaces: observable,
            videoWidth: observable,
            highlights: observable,
            resetFilters: action,
            currentView: observable,
        })


    }

    setCurrentView = (view) => this.currentView = view
    
    getCurrentView = () => this.currentView
    
    setSentiments = (key, view) => this.sentiments[view] = { ...this.sentiments[view], [key]: !this.sentiments[view][key] }
    
    getSentiments = (view) => this.sentiments[view]
    
    getSentimentsTrue = (view) => Object.keys(this.sentiments[view]).filter(key => this.sentiments[view][key])
    
    getSentimentLabels = (view) => Object.keys(this.sentiments[view])
    
    getSentimentsIsEmpty = (view) => this.sentiments[view].length === 0
    
    setTextLen = (length, view) => this.length[view] = length
    
    getTextLen = (view) => this.length[view]
    
    getTextLenIsEmpty = (view) => this.length[view].length === 0
    
    setSecMaxMin = (secMaxMin, view) => this.sec[view] = secMaxMin
    
    setSeconds = (sec, view) => this.sec[view] = sec
    
    getSeconds = (view) => this.sec[view]
    
    getSecondsIsEmpty = (view) => this.sec[view].length === 0
    
    // setSpeakers = (speakers, view) => this.speakers[view] = Object.fromEntries(speakers.map(speaker => [speaker, false]))
    
    setResetSpeakers = (speaker, view) => this.speakers[view] = { ...this.speakers[view], [speaker]: !this.speakers[view][speaker] }
    
    getSpeakersTrue = (view) => Object.keys(this.speakers[view]).filter(key => this.speakers[view][key])
    
    getSpeakersIsEmpty = (view) => Object.keys(this.speakers[view]).length === 0
    
    setSearch = (view, search) => this.search[view] = search
    
    getSearch = (view) => this.search[view]
    
    getSearchEscaped = (view) => this.search[view].replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    isSelectedSentence = (sentence, view) => this.selectedSentences[view].includes(sentence)

    getSelectionOrder = (sentence, view) => {
        const idx = this.selectedSentences[view].indexOf(sentence)
        return idx === -1 ? null : idx + 1
    }
    
    getSelectedSentencesLength = (view) => this.selectedSentences[view].length
    
    hasSelectedSentences = (view) => !this.selectedSentences[view].length <= 0
    
    howManySelectedSentences = (view) => this.selectedSentences[view].length
    
    setAllSelectedSentences = (sentences, view) => {
        this.selectedSentences[view] = []
        sentences.forEach(sentence => this.selectedSentences[view].push(sentence['id']))
    }
    
    setSelectedSentences = (id, view) => this.selectedSentences[view] = [...this.selectedSentences[view], id]
    
    getSelectedSentences = (view) => this.selectedSentences[view]
    
    resetSelectedSentences = (view) => this.selectedSentences[view] = []
    
    removeSelectedSentence = (sentence, view ) => {
        const index = this.selectedSentences[view].indexOf(sentence)
        if (index > -1) {
            this.selectedSentences[view].splice(index, 1)
        }
    }

    setSubtitlesOnOff = (view) => this.subtitles[view] = !this.subtitles[view] 
    
    getSubtitlesOnOff = (view) => {
        return this.subtitles[view]
    }
    
    setSpacesTo = (view, value) => this.spaces[view] = value
    
    getSpaces = (view) => this.spaces[view]
    
    setSpacesOnOff = (view) => this.spaces[view] = !this.spaces[view] 
   
    getSpacesOnOff = (view) => this.spaces[view]

    setVideoWidth = (width, view) => {
        this.videoWidth[view] = width;
        // Save to localStorage
        const currentVideoWidths = getLocalStorage('videoWidths') || {};
        currentVideoWidths[view] = width;
        setLocalStorage('videoWidths', currentVideoWidths);
    }
    
    getVideoWidth = (view) => this.videoWidth[view]

    setSpeakers = (speakers, view) => this.speakers[view] = Object.fromEntries(speakers.map(speaker => [speaker, false]));
    getSpeakers = (view) => this.speakers[view]

    setHighlight = (clipId, start, end) => {
        // A freshly drawn/changed highlight starts with no extra breathing room.
        // padStart/padEnd = seconds added before/after the phrase via the +/- timecode buttons.
        // incBefore/incAfter = pull in the red "borrowed" words from the neighbouring clip.
        this.highlights[clipId] = { start: Math.min(start, end), end: Math.max(start, end), padStart: 0, padEnd: 0, incBefore: false, incAfter: false };
    }
    // Toggle whether the highlight reaches into the borrowed (red) words on one side.
    toggleHighlightStolen = (clipId, side) => {
        const hl = this.highlights[clipId];
        if (!hl) return;
        if (side === 'after') this.highlights[clipId] = { ...hl, incAfter: !hl.incAfter };
        else this.highlights[clipId] = { ...hl, incBefore: !hl.incBefore };
    }
    // Nudge the highlight's in/out a touch earlier/later (give the kept phrase more or less
    // room) without changing which words are highlighted. Clamped so it can't invert.
    setHighlightPad = (clipId, padStart, padEnd) => {
        const hl = this.highlights[clipId];
        if (!hl) return;
        this.highlights[clipId] = { ...hl, padStart, padEnd };
    }
    getHighlight = (clipId) => this.highlights[clipId] || null
    clearHighlight = (clipId) => {
        const updated = { ...this.highlights };
        delete updated[clipId];
        this.highlights = updated;
    }
    resetHighlights = () => { this.highlights = {} }
    hasHighlight = (clipId) => !!this.highlights[clipId]
    hasAnyHighlights = () => Object.keys(this.highlights).length > 0

    resetAllSpeakers = () => {
         // reset booles to false in all views
        [CREATE_VIDEO, CHART, CHERRY_PICK].forEach(view => {
            Object.keys(this.speakers[view]).forEach(key => {
                this.speakers[view][key] = false
                })
         })
    }

    resetFilters = (length, sec, view) => {
        runInAction(() => {
            // Reset only the specified view's filters
            this.sentiments[view] = SENTIMENTS;
            this.length[view] = length;
            this.sec[view] = sec;
            this.subtitles[view] = true;
            this.spaces[view] = false;
            this.search[view] = '';
            this.selectedSentences[view] = [];
            this.highlights = {};
            // On purpose not resetting the video width and precision

        })
    }
}

const filterStore = () => new FilterStore()

export default filterStore
